import AjaxUtility from '../Utility/AjaxUtility';

const MAX_LENGTH_M = 80;

export default class Articletool {
	constructor() {
		this.container = document.getElementById('articletool');
		if (!this.container) {
			return;
		}
		this.resultsContainer = document.getElementById('articletool-results');

		this.inputs = {
			product: document.getElementById('articletool-product'),
			length: document.getElementById('articletool-length'),
			width: document.getElementById('articletool-width'),
			height: document.getElementById('articletool-height')
		};

		this.products = window.articletooldata || {};
		this.debounceTimer = null;

		this.inputs.product.addEventListener('change', () => {
			this.repopulateDimensionDropdowns();
			this.scheduleCalculation();
		});
		['length', 'width', 'height'].forEach((key) => {
			this.inputs[key].addEventListener('change', () => this.scheduleCalculation());
		});

		this.repopulateDimensionDropdowns();
		this.scheduleCalculation();
	}

	currentProduct() {
		const uid = parseInt(this.inputs.product.value, 10);
		return this.products[uid] || null;
	}

	repopulateDimensionDropdowns() {
		const product = this.currentProduct();
		if (!product) {
			return;
		}

		this.fillBlockMultipleDropdown(this.inputs.length, product.blocLength);
		this.fillBlockMultipleDropdown(this.inputs.width, product.blocWidth);
		this.fillLayerDropdown(this.inputs.height, product);
	}

	fillBlockMultipleDropdown(select, blocSize) {
		select.innerHTML = '';
		const maxCount = Math.floor(MAX_LENGTH_M / blocSize);
		for (let n = 1; n <= maxCount; n++) {
			const meters = (n * blocSize).toFixed(2).replace('.', ',');
			const option = document.createElement('option');
			option.value = String(n);
			option.textContent = `${meters} Meter (${n} Stück)`;
			select.appendChild(option);
		}
	}

	fillLayerDropdown(select, product) {
		select.innerHTML = '';
		select.disabled = false;

		const maxLayers = product.isTunnel ? 1 : Math.max(1, parseInt(product.maxLayers, 10) || 1);

		for (let n = 1; n <= maxLayers; n++) {
			const fullMeters = (n * product.displayBlocHeight + product.basePlateHeight).toFixed(2).replace('.', ',');
			const fullLabel = n === 1 ? '1 Lage' : `${n} Lagen`;
			const fullOption = document.createElement('option');
			fullOption.value = String(n);
			fullOption.textContent = `${fullMeters} Meter (${fullLabel})`;
			select.appendChild(fullOption);

			// Extra ("½ Lage") step on top of n full layers, mirroring getHeightSteps()
			// (offered on 1 … maxLayers-1, never on the top full-layer count).
			if (product.hasExtraBloc && n < maxLayers) {
				const extraMeters = (n * product.displayBlocHeight + product.extraBlocHeight + product.basePlateHeight).toFixed(2).replace('.', ',');
				const extraOption = document.createElement('option');
				extraOption.value = String(n);
				extraOption.dataset.extraBloc = '1';
				extraOption.textContent = `${extraMeters} Meter (${n},5 Lagen)`;
				select.appendChild(extraOption);
			}
		}

		if (product.isTunnel) {
			select.value = '1';
			select.disabled = true;
		}
	}

	scheduleCalculation() {
		clearTimeout(this.debounceTimer);
		this.debounceTimer = setTimeout(() => this.runCalculation(), 150);
	}

	runCalculation() {
		const product = this.currentProduct();
		if (!product) {
			return;
		}
		const blocksLength = parseInt(this.inputs.length.value, 10);
		const blocksWidth = parseInt(this.inputs.width.value, 10);
		const heightSelect = this.inputs.height;
		const layers = parseInt(heightSelect.value, 10);
		const selectedOption = heightSelect.options[heightSelect.selectedIndex];
		const extraBloc = selectedOption && selectedOption.dataset.extraBloc === '1' ? 1 : 0;

		if (isNaN(blocksLength) || isNaN(blocksWidth) || isNaN(layers)) {
			return;
		}

		this.resultsContainer.classList.add('is-loading');

		AjaxUtility.request('Articletool', {
			controller: 'Articletool',
			action: 'calculate',
			productUid: parseInt(this.inputs.product.value, 10),
			blocksLength: blocksLength,
			blocksWidth: blocksWidth,
			layers: layers,
			extraBloc: extraBloc
		}).done((html) => {
			this.resultsContainer.innerHTML = html;
		}).fail(() => {
			this.resultsContainer.innerHTML = '<p class="article-list-tool__error">Die Artikelaufstellung konnte nicht berechnet werden. Bitte erneut versuchen.</p>';
		}).always(() => {
			this.resultsContainer.classList.remove('is-loading');
		});
	}
}
